<template>
  <div class="sider">
    <div class="topclass-style">
    </div>
    <Menu :active-name="activeName" :open-names="openNames" ref="custommenu" theme="dark" width="auto">
      <template v-for="item in menuList">
        <Submenu :key="item.id" :name="item.id" v-if="item.child&&item.child.length>0">
          <template slot="title">
            <div class="flex-row menu-item">
              <i :class="item.icon"></i>
              <span class="menu-item-text">{{item.title}}
                  <span class="red-bot-style" v-if="item.num">{{item.num}}</span>
              </span>
            </div>
          </template>
          <MenuItem :key="child.id" :name="child.url||child.id" :to="{path:child.url,query:child.query}"
                    v-for="child in item.child">{{child.title}}
          </MenuItem>
        </Submenu>
        <MenuItem :key="item.id" :name="item.url||item.id" :to="{path:item.url,query:item.query}"
                  v-if="!(item.child&&item.child.length>0)">
          <div class="flex-row menu-item">
            <i :class="item.icon"></i>
            <span class="menu-item-text">{{item.title}}
            <span class="red-bot-style" v-if="item.num">{{item.num}}</span>
          </span>
          </div>
        </MenuItem>
      </template>
    </Menu>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'SiderContent',
  props: {
    menuList: Array
  },
  data () {
    return {
      select: '',
      showblackcolor: false
    }
  },
  computed: {
    getAllList () {
      let list = []
      this.menuList.map((res) => {
        list.push(res)
        if (res.child && res.child.length) {
          this.formatlist(list, res.child)
        }
        if (res.urlchild && res.urlchild.length) {
          res.urlchild.map((cchild) => {
            list.push(cchild)
          })
        }
      })
      return list
    },
    activeName () {
      return this.$route.path
    },
    openNames () {
      let optionList = this.getAllList
      if (optionList && optionList.length) {
        this.$nextTick(() => {
          this.$refs.custommenu.updateActiveName()
        })
        return optionList.map(res => {
          return res.url || res.id
        })
      } else {
        return []
      }
    },
  },
  mounted () {
    // Bus.$on('onhomemounted', () => {
    //   this.showblackcolor = true
    // })
    // Bus.$on('onhomedestroyed', () => {
    //   this.showblackcolor = false
    // })
    // Bus.$on('onmenuindexchange', ({item, index}) => {
    //   this.select = item.title
    //   this.onItemMenu(item, index)
    // })
    // let index = this.$store.state.app.menuIndex
    // if (this.menuList.length > 0) {
    //   let item = this.menuList[index]
    //   let title = item.title
    //   let id = item.id
    //   let path = item.path
    //   this.changeMenuTitle(title)
    //   this.changeMenuIndex(index)
    //   this.changeMenuPath(path)
    //   this.select = title
    //   this.menuTitle = title
    // }
  },
  methods: {
    formatlist (list, child) {
      child.map((res) => {
        list.push(res)
        if (res.child && res.child.length) {
          this.formatlist(list, res.child)
        }
        if (res.urlchild && res.urlchild.length) {
          res.urlchild.map((cchild) => {
            list.push(cchild)
          })
        }
      })
    },
    ...mapActions([
      'changeMenuId',
      'changeMenuTitle',
      'changeMenuPath',
      'changeMenuIndex',
      'changeSearchParams'
    ]),
    // onItemMenu (item, index) {
    //   let that = this
    //   let path = item.path
    //   let title = item.title
    //   this.menuTitle = title
    //   this.select = title
    //   this.changeMenuIndex(index)
    //   this.changeMenuTitle(title)
    //   this.changeMenuPath(path)
    //   // 切换menu时，清空
    //   let params = {}
    //   this.changeSearchParams(params)
    //   this.$emit('onSideMenuClick', item)
    //   that.$router.replace(path)
    // }
  },
  destroyed () {
    // this.changeMenuIndex(0)
    // Bus.$off('onhomemounted')
    // Bus.$off('onhomedestroyed')
    // Bus.$off('onmenuindexchange')
  }
}
</script>

<style scoped lang="scss">

  .left-slide-img-style {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  .sider {
    position: relative;
    height: calc(100% - 74px);

    .menu-item {
      justify-content: flex-start;
      position: relative;
      right: 10px;
      cursor: pointer;

      .menu-item-img {
        width: 27px;
        height: 30px;
      }

      .menu-item-text {
        margin-left: 8px;
        font-size: 15px;
        white-space: nowrap;
      }
    }

    .add {
      position: absolute;
      bottom: 40px;
      left: 50%;
      margin-left: -60px;
      width: 120px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border-radius: 6px;
      border: 1px solid white;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      letter-spacing: 1px;
      cursor: pointer;

      .menu-img {
        width: 20px;
        height: 16px;
      }
    }
  }


  .red-bot-style {
    min-width: 16px;
    height: 16px;
    line-height: 16px;
    padding: 0 5px;
    text-align: center;
    position: absolute;
    border-radius: 32px;
    flex-shrink: 0;
    right: -40px;
    top: 2px;
    font-size: 5px;
    color: white;
    background-color: red;
  }

  .topclass-style {
    width: 100%;
    height: 10px;
    background-color: #f5f7f9;
    display: block;
  }

  .blact-style {
    background-color: #4A4A4A;
  }

  @media (max-width: 1204px) {
    .topclass-style {
      display: none;
    }
  }
</style>
<style scoped>
  .sider >>> .ivu-menu-dark {
    background: transparent;
  }

  .sider >>> .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title {
    background: transparent;
  }
</style>
